import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const { Form } = Common;

const ExchangeListHeader = ({ canAdd = false, companyId = '', t }) => {
  return (
    <Common.Header title={t('exchange.exchange_title')}>
      <div className="btn-group pull-right">
        {canAdd && (
          <Form.Link to={`/companies/${companyId}/exchange/add`} className="btn btn-info">
            {t('actions.add')}
          </Form.Link>
        )}
      </div>
    </Common.Header>
  );
};

export default translate()(ExchangeListHeader);



// WEBPACK FOOTER //
// src/modules/secured/modules/exchange/components/list/ExchangeListHeader.js